import { MonetateExperience } from './index.d'

export const eventAnalytics = (campaigns: Array<MonetateExperience>) => {
  if (!campaigns || campaigns.length === 0) return

  const eventableCampaigns = campaigns.map(campaign => {
    const { id, experienceName, variantLabel } = campaign
    return {
      id: id,
      key: experienceName,
      reports: [],
      split: variantLabel,
    }
  })

  document.body.dispatchEvent(
    new CustomEvent('dataStateChange', {
      detail: {
        action: 'managedImpression',
        campaigns: eventableCampaigns,
      },
    }),
  )
}
